import { apiClient } from "~/lib/client";
import { handleApiError, handleResponse } from "~/utils/response";
import { useMutation } from "@tanstack/react-query";
import { BookingRules, BookingRulesExtra, BookingRulesExtraResponse, BookingRulesResponse, Schedule, ScheduleResponse } from "../types";

export const useScheduleMutation = () => {
    return useMutation({
        mutationFn: async (data: Schedule) => {
            try {
                const response = await apiClient('/admin/schedules', {
                    method: 'POST',
                    body: JSON.stringify(data)
                });
                const result = await handleResponse<ScheduleResponse>(response);

                if (!result.success) {
                    throw new Error(result.error);
                }

                return result.data;
            } catch (error) {
                handleApiError(error);
                throw error;
            }
        }
    });
};

export const useBookingRulesMutation = () => {
    return useMutation({
        mutationFn: async (data: BookingRules) => {
            try {
                const response = await apiClient('/admin/booking-rules', {
                    method: 'POST',
                    body: JSON.stringify(data)
                });
                const result = await handleResponse<BookingRulesResponse>(response);

                if (!result.success) {
                    throw new Error(result.error);
                }

                return result.data;
            } catch (error) {
                handleApiError(error);
                throw error;
            }
        }
    });
};

export const useBookingRulesExtraMutation = () => {
    return useMutation({
        mutationFn: async (data: BookingRulesExtra) => {
            try {
                const response = await apiClient('/admin/booking-rules-advanced', {
                    method: 'POST',
                    body: JSON.stringify(data)
                });
                const result = await handleResponse<BookingRulesExtraResponse>(response);

                if (!result.success) {
                    throw new Error(result.error);
                }

                return result.data;
            } catch (error) {
                handleApiError(error);
                throw error;
            }
        }
    });
};
